import {RawLocation} from "vue-router";
import {Vue} from "vue-property-decorator";
import { property } from "lodash";

interface IRangeSeparatorsData {
  minus?: string
  plus?: string
  between?: string
}

export interface IRangeSeparators extends IRangeSeparatorsData {
  minus: string
  plus: string
  between: string
}

class RangeSeparators implements IRangeSeparators {
  minus: string
  plus: string
  between: string

  constructor(data?: IRangeSeparatorsData) {
    let sign = data?.minus
    this.minus = (sign !== undefined) ? sign : '-'
    sign = data?.plus
    this.plus = (sign !== undefined) ? sign : '+'
    sign = data?.between
    this.between = (sign !== undefined) ? sign : '-'
  }
}

export function rangeLabel (from?: string | number, to?: string | number, wrapper?: Function, separators?: IRangeSeparatorsData): string {
  let sep = new RangeSeparators(separators);
  if (wrapper) {
    from = from ? wrapper(from) : from
    to = to ? wrapper(to) : to
  }
  if (from && to) {
    let res = from as string;
    if (from !== to) {
      res += sep.between + to
    }
    return res;
  } else if (from) {
    return from + sep.plus
  } else if (to) {
    return sep.minus + to
  } else {
    return ''
  }
}

export function updateItems<T>(items: T[] | undefined, action: Function): Promise<any> {
  let promise: Promise<any>[] = [];
  items?.forEach((item: T, index: number) => {
    promise.push(new Promise<void>((resolve) => {
      updateItem<T>(item, action)
        .then(resolve)
        .catch(() => {
          items.splice(index, 1);
          resolve();
        });
    }));
  });
  return Promise.all(promise)
}

export function updateItem<T>(item: T, action: Function, key: string = 'id', wrapped: boolean = false): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    let keyField = (item as any)[key];
    if (keyField) {
      let keyData = wrapped ? { key: keyField } : keyField;
      action(keyData)
        .then((res: T) => {
          if ((res as any)?.validate()) {
            (item as any).update(res);
            resolve();
          } else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    } else {
      reject()
    }
  });
}

export function newLines (value: string, cases: number = 1): string {
  let res = value;
  for (let i = 0; i < cases; i++) {
    res = res.replace(/\s/, '<br>');
  }
  return res;
}

export function mountScript(url: string): void {
  let script = document.createElement('script');
  script.setAttribute('src', url);
  document.head.appendChild(script);
}

export function getError(res: any): string {
  return res.response.data.error || res;
}

export function closeAndMove(vm: Vue, to: RawLocation): void {
  vm.$storage.actions.closeModal();
  vm.$router.push(to);
}
